/* Complete the set - Kukoon's own add-to-basket popup (v2).

   Replaces Rebuy widget 181444, whose "same parent SKU" rule stopped
   returning anything on 29 Sep 2026 (Rebuy's metafield matching, not ours).

   WHAT IT OFFERS, when a product goes in the basket from its product page:
     1. the rest of its SET - every product with the same Kukoon.parent_sku
        ("Renuu Zoe Beige"): runner, circle, doormat, kitchen mat, bath mat,
        cushion. Never another rug, and within a kind the piece with this
        product's own name ("- Maren") - one parent SKU can hold ten colours.
     2. then, if there is room and no cushion yet, the cushion covers that
        best match its colour.
     Sold out, already in the basket, underlay and the product itself are
     skipped. Up to 4. Nothing to offer means no popup - the basket drawer
     opens exactly as it always did.

   HOW IT BEHAVES
     - It comes INSTEAD of the drawer, not on top of it. The drawer opens
       when the shopper closes the popup; Checkout goes straight to checkout.
     - One decision per screen: "Add all" is the main button, each card has
       its own Add, Checkout is second, "No thanks" is a quiet link.
     - A progress bar towards the spend threshold (KukoonSetConfig.tier -
       £200 / €230), from the real basket total, updated after every add.
     - Closed without adding anything: not shown again for THAT product this visit
       (15 Oct 2026, Jack: a no to Zoe's pieces says nothing about Dusk's - it used
       to stop for every product after two closes).

   DATA: the search's own product list (ps parent SKU, tg tags, co colour,
   r/rc reviews, oos sold out, im photos), then Shopify's Storefront API for
   live sizes, stock, price and was-price in the shopper's own market, and
   /cart.js for the basket.

   TEST MODE: KukoonSetConfig.enabled is false for shoppers. ?kset=1 turns it
   on for one browser tab (theme.liquid removes the Rebuy popup there);
   ?kset=0 turns it off. */
(function () {
  'use strict';
  var KEY = 'kukoon.kset', DISMISS = 'kukoon.kset.dismissed';
  try {
    var q = new URLSearchParams(location.search).get('kset');
    if (q === '1') sessionStorage.setItem(KEY, '1');
    if (q === '0') sessionStorage.removeItem(KEY);
  } catch (e) {}
  var C = window.KukoonSetConfig || {};
  var testOn = false;
  try { testOn = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
  // LIVE SWITCH: Upsell Radar -> Offers -> Complete the set popup. The flag
  // comes in the search settings file (config.json -> upsell.popup) and is
  // remembered per browser, so it applies from the shopper's next page (the
  // Rebuy popup is removed on that page by theme.liquid, from the same flag -
  // never two popups). Switched off there, it stops from the next page too.
  var LIVE = 'kukoon.kset.live', liveOn = false;
  try { liveOn = localStorage.getItem(LIVE) === '1' && !/[?&]kset=0/.test(location.search); } catch (e) {}
  try {
    var su = (window.KukoonSearch || {}).settingsUrl || 'https://api.kukoonrugs.com/search/config.json';
    fetch(su, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j) return;                      // can't tell: leave it as it was
      var on = !!(j.upsell && j.upsell.popup === true);
      try { if (on) localStorage.setItem(LIVE, '1'); else localStorage.removeItem(LIVE); } catch (e) {}
      // 15 Oct 2026: and on THIS page too - a shopper's first product page used to
      // get no popup at all, because the flag only took effect from the next page
      liveOn = on && !/[?&]kset=0/.test(location.search);
      document.documentElement.classList.toggle('kset-on', !!(C.enabled || testOn || liveOn));
    }).catch(function () {});
  } catch (e) {}
  // whether the popup is on is asked at the moment of each add (KukoonSet.active),
  // so the switch arriving a moment after the page loads still counts on this page
  var gate = function () { return !!(C.enabled || testOn || liveOn); };
  if (gate()) document.documentElement.classList.add('kset-on');

  var S = window.KukoonSearch || {};
  var MAX = 5;           // 3 in view, the rest one scroll away
  var TIER = C.tier || { GBP: 200, EUR: 230 };
  var TIER_LABEL = C.tierLabel || 'an extra discount';
  // the code they must type at checkout - never applied for them: having to
  // use it is the point (exclusivity). Blank hides every mention of a code.
  var CODE = String(C.code || '').trim().toUpperCase();

  /* A/B test: which photo sells the set - the overhead product shot, or the
     piece in a room. Each browser is put in one group for good (localStorage)
     so a shopper never flips between them, and every event says which group
     it came from (surface "set-overhead" / "set-room"). C.ab off: everyone
     sees overhead. ?kset_ab=room or =overhead forces a group, for checking. */
  var AB = 'overhead';
  try {
    var forced = new URLSearchParams(location.search).get('kset_ab');
    if (forced === 'room' || forced === 'overhead') localStorage.setItem('kukoon.kset.ab', forced);
    if (C.ab || forced) {
      AB = localStorage.getItem('kukoon.kset.ab');
      if (AB !== 'room' && AB !== 'overhead') {
        AB = Math.random() < 0.5 ? 'room' : 'overhead';
        localStorage.setItem('kukoon.kset.ab', AB);
      }
    }
  } catch (e) {}

  /* A/B test (12 Oct 2026): what goes in the first slot. 75% of adds come
     from it and slots 4-5 sold nothing, so the lead piece decides the popup.
     "small": the easy yes first (doormat, mats, then runner) - as before.
     "runner": the range's own runner first on a rug or circle - runners took
     half the popup's revenue at 2-3x a doormat's price. 50/50 per browser,
     kept for good; every event and order line says which group.
     14 Oct 2026 (Jack): runner first for everyone - after 1,563 popups it made
     £0.74 a popup against £0.14 for small-first. The split is off; C.leadTest
     true brings it back. ?kset_lead=runner|small still forces one for testing. */
  var LEAD = 'runner';
  try {
    var forcedLead = new URLSearchParams(location.search).get('kset_lead');
    if (forcedLead === 'runner' || forcedLead === 'small') localStorage.setItem('kukoon.kset.lead', forcedLead);
    if (C.leadTest === true || forcedLead) {
      LEAD = localStorage.getItem('kukoon.kset.lead');
      if (LEAD !== 'runner' && LEAD !== 'small') {
        LEAD = Math.random() < 0.5 ? 'runner' : 'small';
        localStorage.setItem('kukoon.kset.lead', LEAD);
      }
    }
  } catch (e) {}
  /* A/B test (15 Oct 2026): the rug's own underlay as the 2nd card - "on" - or not
     - "off". 50/50 per browser, kept for good. Both groups are stamped on the basket
     (cart attribute _kset_ul) whenever the popup could have offered underlay, so the
     order history can compare underlay take-up on rug orders, from every source
     (product page, basket, popup), not just what the popup sold.
     ?kset_ul=on|off forces one for testing. */
  /* ENDED 20 Oct 2026 (Jack): the card sold underlay through the popup but rug
     orders with underlay were level (19.7% with it, 21.2% without) - it moved
     underlay sales from the product page rather than adding any. Everyone now
     gets the plain popup: the runner (or other piece) on its own. The old
     per-browser group is cleared so nobody keeps seeing the card. */
  var UL = 'off';
  try { localStorage.removeItem('kukoon.kset.ul'); } catch (e) {}
  // the A/B groups as the events and the _upsell line property carry them,
  // e.g. "set-overhead-lead-runner" (Upsell Radar reads the photo group first)
  var GROUP = 'set-' + AB + '-lead-' + LEAD + '-ul' + (UL === 'on' ? '1' : '0');
  // the event log keeps 20 characters of the surface - the full name lost its -ul1/-ul0
  // (15 Oct 2026), so events carry a short code: set-ov|rm - ru|sm - ul1|ul0
  var EVGROUP = 'set-' + (AB === 'room' ? 'rm' : 'ov') + '-' + (LEAD === 'runner' ? 'ru' : 'sm') + '-ul' + (UL === 'on' ? '1' : '0');

  /* ------------------------------------------------------------ data */
  var indexP = null;
  function loadIndex() {
    if (indexP) return indexP;
    // the page's one shared download (theme.liquid, 12 Oct 2026)
    if (window.KukoonIndex) {
      indexP = window.KukoonIndex()
        .then(function (d) { return d.length && 'ps' in d[0] ? d : []; })
        .catch(function () { return []; });
      return indexP;
    }
    var get = function (u) {
      return fetch(u, { credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error(r.status); return r.json();
      });
    };
    indexP = (S.liveIndexUrl ? get(S.liveIndexUrl) : Promise.reject())
      .then(function (d) { if (!d.length || !('ps' in d[0])) throw new Error('no ps'); return d; })
      .catch(function () { return S.indexUrl ? get(S.indexUrl) : []; })
      .catch(function () { return []; });
    return indexP;
  }
  var route = function (k, d) { return (window.routes && window.routes[k]) || d; };
  function getCart() {
    return fetch(route('cart_url', '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { return { items: [], total_price: 0 }; });
  }

  var has = function (p, t) { return (p.tg || []).indexOf(t) !== -1; };
  function kind(p) {
    var t = p.t || '';
    if (/underlay/i.test(t)) return 'underlay';
    // stair carpets and cut-to-measure lengths are never offered (Jack, 20 Oct 2026) -
    // their names say 'runner', so they were being picked as a rug's runner
    if (/stair|cut to measure/i.test(t) || has(p, 'Stair Carpet')) return 'stair';
    if (has(p, 'Cushion') || /cushion/i.test(t)) return 'cushion';
    if (/bath(room)? mat/i.test(t)) return 'bathmat';
    if (/kitchen mat/i.test(t)) return 'kitchen';
    if (has(p, 'Doormat') || /doormat/i.test(t)) return 'doormat';
    if (has(p, 'Runner Rugs') || /runner/i.test(t)) return 'runner';
    if (has(p, 'Circle') || /\b(circle|round)\b/i.test(t)) return 'circle';
    return 'rug';
  }
  /* The order things are offered in: the easy yes first. Somebody who has
     just spent £200 on a rug will add a £30 doormat on impulse; a second
     £255 rug is a new decision. So small, cheap pieces lead and the big
     ones sit further along, one scroll away - still there for the shopper
     furnishing a whole room. */
  var ORDER = {
    rug:     ['doormat', 'bathmat', 'cushion', 'kitchen', 'runner', 'circle'],
    runner:  ['doormat', 'bathmat', 'cushion', 'kitchen', 'rug', 'circle'],
    circle:  ['doormat', 'cushion', 'bathmat', 'kitchen', 'runner', 'rug'],
    doormat: ['bathmat', 'kitchen', 'cushion', 'runner', 'rug', 'circle'],
    kitchen: ['doormat', 'bathmat', 'cushion', 'runner', 'rug', 'circle'],
    bathmat: ['doormat', 'kitchen', 'cushion', 'runner', 'rug', 'circle'],
    cushion: ['doormat', 'bathmat', 'kitchen', 'runner', 'rug', 'circle'],
  };
  // short, one-line names: "William Morris circle", not "... circle rug"
  var NOUN = { rug: 'rug', runner: 'runner', circle: 'circle', doormat: 'doormat', kitchen: 'kitchen mat',
    bathmat: 'bath mat', cushion: 'cushion' };

  /* Cushions for a rug with no cushion of its own, by the rug's main colour
     (its colour metafield) only - and only where the pairing is obvious. Only
     a handful of cushion covers exist, all in one distressed style, so a weak
     match (a pink rug, a terracotta cushion) is worse than none. */
  var CUSHION_MIN_SOLD = 20;   // units in 120 days
  var CUSHION_FOR = {
    Beige: ['Beige'], Cream: ['Beige'], Ivory: ['Beige'], White: ['Beige'], Natural: ['Beige'],
    Taupe: ['Beige'], Brown: ['Beige'],
    Blue: ['Blue', 'Green'], Navy: ['Blue', 'Green'], Teal: ['Green', 'Blue'],
    Green: ['Green'], Sage: ['Green'], Olive: ['Green'],
    Red: ['Red'], Wine: ['Red'], Burgundy: ['Red'],
    Orange: ['Orange'], Terracotta: ['Orange'], Rust: ['Orange'],
    Multicolour: ['Multicolour'],
  };

  var COLOURS = ['Beige', 'Cream', 'Ivory', 'White', 'Natural', 'Brown', 'Taupe', 'Grey', 'Silver',
    'Charcoal', 'Black', 'Blue', 'Navy', 'Teal', 'Green', 'Sage', 'Olive', 'Red', 'Wine', 'Burgundy',
    'Pink', 'Orange', 'Terracotta', 'Rust', 'Ochre', 'Yellow', 'Gold', 'Purple', 'Multicolour'];
  var FAMILY = {
    Beige: 'n', Cream: 'n', Ivory: 'n', White: 'n', Natural: 'n', Brown: 'n', Taupe: 'n',
    Grey: 'g', Silver: 'g', Charcoal: 'g', Black: 'g',
    Blue: 'c', Navy: 'c', Teal: 'c', Green: 'c', Sage: 'c', Olive: 'c',
    Red: 'w', Wine: 'w', Burgundy: 'w', Pink: 'w', Orange: 'w', Terracotta: 'w', Rust: 'w',
    Ochre: 'w', Yellow: 'w', Gold: 'w', Purple: 'w', Multicolour: 'm',
  };
  function colours(p) {
    var out = {};
    if (p.co) String(p.co).split(/[,/|]/).forEach(function (c) { c = c.trim(); if (c) out[c] = 1; });
    (p.tg || []).forEach(function (t) { if (COLOURS.indexOf(t) !== -1) out[t] = 1; });
    return Object.keys(out);
  }
  // the same colour scores 3 when it is the cushion's own; the same family
  // (a blue rug, a teal cushion) scores 2
  function colourScore(rug, cushion) {
    var rc = colours(rug), cc = colours(cushion), main = cushion.co;
    var s = 0;
    cc.forEach(function (c) {
      if (rc.indexOf(c) !== -1) s += c === main ? 3 : 1;
      else if (rc.some(function (r) { return FAMILY[r] && FAMILY[r] === FAMILY[c] && FAMILY[c] !== 'm'; })) s += c === main ? 2 : 0;
    });
    return s;
  }
  // "Flatwoven Washable Indoor Doormat - Zoe" -> "Zoe"
  var rangeName = function (p) {
    var t = p.t || '', i = t.lastIndexOf(' - ');
    if (/choose your colou?r/i.test(t)) return '';
    return i === -1 ? '' : t.slice(i + 3).trim();
  };

  /* Natural fibre (30 Sep 2026): a jute rug goes with jute, not with a beige
     cushion. Real jute, coir, sisal, seagrass - not the washable "jute style"
     prints, which are cotton and carry a Jute tag for search. */
  var NATURAL_MAT = /^(jute|coir|sisal|seagrass)\b/i;
  function isNatural(p) {
    if (NATURAL_MAT.test(p.mat || '')) return true;
    return (p.tg || []).indexOf('Jute') !== -1 && !p.wash && !/jute[- ]style/i.test(p.t || '');
  }
  // what a natural rug is offered from outside its own set, in this order
  var NATURAL_KINDS = ['doormat', 'circle', 'runner'];
  var NATURAL_MIN_SOLD = 5;    // units in 120 days: proven, not filler

  /* 12 Oct 2026, from the first week's numbers (6,578 popups):
     - the colour-matched cushion was offered 3,446 times for 29 adds, and the
       natural-fibre picks 711 times for 2 - filler, now off (C.fillers: true
       brings both back);
     - these pieces were offered 80+ times and never added once;
     - a popup with nothing but a cushion in it is skipped: the basket opens
       as it would without the popup. */
  var NEVER = { 'rustic-jute-round-natural-circle-nursery-rug': 1, 'soft-washable-cream-doormat-adeline': 1,
    'soft-cream-boho-runner-luma': 1, 'sage-green-vintage-runner-isadora': 1, 'soft-washable-vintage-doormat-elsie': 1,
    'soft-washable-vintage-bathroom-mat-amelia': 1, 'distressed-terracotta-washable-runner-rowe': 1 };
  var FILLERS = C.fillers === true;
  /* One set, however the parent SKU was typed (12 Oct 2026): "Renuu Bala Blue"
     and "Renuu Bala", "Ludlow Moonshine Grey" and "Ludlow_Moonshine_Grey" are
     the same set, and an exact match left Bala, Lottie and Moonshine - 600
     sales a quarter - with no popup. Case, _ and - are ignored, and one may
     be the other plus a word (the colour). */
  var normSet = function (v) { return String(v || '').toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim(); };
  var sameSet = function (a, b) { return !!a && !!b && (a === b || a.indexOf(b + ' ') === 0 || b.indexOf(a + ' ') === 0); };

  /* Choose Your Colour rugs (20 Oct 2026, Jack): one product, the colour is
     picked as a size. Its product colour is fixed (Green for the jute one),
     so the nearest-colour rules offered the same runner whatever was picked -
     a navy rug got a green runner. Here the picked colour decides: that
     colour's own runner, or no runner at all if it is sold out or unknown.
     Keep this map the same in kukoon-set.js and kukoon-cart.js. */
  var COLOUR_RUNNER = {
    'natural-jute-border-rug-choose-your-colour': {
      navy: 'navy-border-jute-runner-rug-juliette-navy',
      green: 'green-cotton-border-natural-jute-hallway-runner-rug',
      rust: 'terracotta-border-jute-runner-rug-juliette-rust',
      beige: 'beige-cotton-border-natural-jute-area-runner-rug',   // the right one of two near-twins (Jack, 20 Oct)
      black: 'black-border-jute-runner-rug-juliette-black',
      grey: 'grey-blue-cotton-border-natural-hallway-jute-runner-rug'
    },
    'premium-shaggy-rug-choose-your-colour': {
      grey: 'premium-grey-shaggy-runner-rug-dove',
      cream: 'premium-cream-shaggy-runner-rug-lace',
      'sage green': 'premium-sage-green-shaggy-runner-rug-sage'
    }
  };
  // the runner for the colour in a size title like 'Navy / 120cm x 170cm';
  // false = take every runner out and offer none, null = not one of these rugs
  function colourRunner(handle, variantTitle) {
    var m = COLOUR_RUNNER[handle];
    if (!m) return null;
    var parts = String(variantTitle || '').toLowerCase().split('/').map(function (s) { return s.trim(); });
    if (parts.some(function (s) { return /runner/.test(s); })) return false;   // they picked the runner itself
    for (var i = 0; i < parts.length; i++) if (m[parts[i]]) return m[parts[i]];
    return false;
  }
  /* The rug's own runner size (20 Oct 2026, Jack). 86 rugs sell their runner
     as a size of the rug, not as its own product, so nothing above could find
     it - Seraphina's popup fell back to best sellers. These are the ones whose
     runner photo Jack checked one by one (runner-variant-photos-check-2026-10-20):
     rug handle -> its runner size(s) and that photo. The card offers only those
     sizes, adds that size of the same product, and never shows the rug photo
     as a runner. A rug not listed here gets nothing new. Keep this list the
     same in kukoon-set.js and kukoon-cart.js. */
  var RUNNER_SIZE = {
    'beige-linear-bordered-area-rug': { v: ['43617867890843'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/ikaro-rin-RRL-stair-and-floor-final.jpg' },
    'beige-wool-style-rug-tala': { v: ['43758661238939'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/bouclair-tala-00114-overhead-RR-sq.jpg' },
    'brown-spotted-stripes-mat-luna': { v: ['43777493532827'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/20250701_1151_Long_Kitchen_Runner_remix_01jz2sr55re989wbakx18qn0b7.png' },
    'cosy-soft-abstract-lined-beige-moroccan-berber-bedroom-rug': { v: ['43487159845019'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Medini_20Linea_20Beige_20Insta_5B2_5D.jpg' },
    'cream-beige-boho-rug-sachi': { v: ['43749215436955'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/milako-sachi-00066-RR-overhead-sq.jpg' },
    'distressed-blue-damask-washable-rug': { v: ['43484918481051'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/renuu-BalaBlue-03274.jpg' },
    'faded-distressed-navy-oriental-pattern-rug': { v: ['43486647845019'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Oscar-Paris-Navy-Close-Up---Traditional-Distrissed-Navy-Living-Room-Rug_5B4_5D.jpg' },
    'gold-abstract-marble-pattern-living-room-rugs': { v: ['43485294559387'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/hatton-marble-gold-22.jpg' },
    'grey-distressed-multicoloured-abstract-living-room-rug': { v: ['43484988997787'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/song-multi-9486_5B5_5D.jpg' },
    'marble-effect-lustre-rug-ori': { v: ['45664219791515'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Kesia_Ori_Room_web__2_Runner.jpg' },
    'modern-gold-abstract-mosaic-living-room-rugs': { v: ['43485294788763'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/hatton-road-gold-17_5B2_5D.jpg' },
    'modern-soft-grey-gold-distressed-abstract-living-room-rug': { v: ['43484988145819', '56732922511741'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/moonshine-grey-8957_5B2_5D.jpg' },
    'multicolour-medallion-area-rug': { v: ['43627137466523'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Oscar-joyful-multi-RR-hall-final.jpg' },
    'pastel-tribal-print-area-room-rug': { v: ['43491306373275'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/sable-multi-9542-3_5B1_5D.jpg' },
    'soft-blue-distressed-abstract-living-room-area-rug': { v: ['43484985720987', '56733222601085'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/bedtime-blue-9225_5B4_5D.jpg' },
    'soft-modern-blue-grey-painted-canvas-effect-rugs': { v: ['43486634410139'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Riveria_Artist_Room_web__2_Runner.jpg' },
    'soft-washable-green-floral-rug-seraphina': { v: ['57943613866365'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/soft-washable-romantic-florals-serafina-room-web-kitchen-RRL-copy_05ca53bc-465f-4b10-aa13-53b295da0718.jpg' },
    'traditional-regal-red-rug-navan': { v: ['43822651703451'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/jasmine-navan-05272-RR-overhead_9e539fc9-6a01-405a-8854-ffe7647200c5.jpg' },
    'vintage-distressed-beige-washable-area-rug-aria': { v: ['45185073184923'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/cleo-1006-RRL-overhead-sq_bb21756f-4c10-4f19-a2d9-f6dd1ea313bd.jpg' },
    'washable-blue-berber-style-rug-yasmine': { v: ['57055443812733', '57055443845501'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/washable-everyday-yasmine-RRL-RR-overhead-SQ.jpg' },
    'washable-blue-geometric-rug-plato': { v: ['54932190495101', '54932190527869'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Everyday-Plato-room-web-RRL-5.jpg' },
    'washable-multicolour-abstract-rug-lissy': { v: ['54922347512189', '54922347544957'], im: 'https://cdn.shopify.com/s/files/1/0602/1070/8635/files/Everyday-Lissy-room-web-RRL-5.jpg' },
    // photos Jack replaced on the to-sort sheet (20 Oct)
    'blush-pink-stripe-shaggy-rug-murano': { v: ['43486641782939'], im: 'https://www.kukoonrugs.com/cdn/shop/files/murano-blush-stripe-4051_5B2_5D.jpg' },
    'grey-scandi-trellis-rug-ashbee': { v: ['43486660264091'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Ashbee-Hazy-Grey-Room-2---Grey-Cream--Soft-Scandi-Boho-Hygge-Living-Room-Rug-Runner-Mat-Large-Small_zpsztjyr0ag_5B5_5D.jpg' },
    'mottled-stripe-dark-green-shaggy-rug-murano': { v: ['43486641979547'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Murano-Stripe-Dark-Green-Close-Up---Mottled-Shaggy-Living-Room-Rug_5B3_5D.jpg' },
    'scandi-grey-cream-rug-ashbee': { v: ['43486659739803'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Ashbee-Benni-Grey-Room-1---Grey-Cream--Soft-Scandi-Boho-Hygge-Living-Room-Rug-Runner-Mat-Large-Small_zps1xvdanlm_5B1_5D.jpg' },
    // the 'needs a photo' sheet, filled in by Jack (20 Oct). h = offer that product
    // instead (its own runner listing, or the Frank rug's runner sold as 'Bedroom')
    'beige-stripe-shaggy-rug-living-room': { v: ['44100318396571'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-murano-biege-stripe-4561.jpg' },
    'blue-oriental-distressed-vintage-rug': { v: ['43486648893595'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Oscar_20Sophia_20Navy_20-_20Blue_20Distressed_20Tradational_20Room_20Rug_5B4_5D.jpg' },
    'distressed-ochre-yellow-pastel-soft-living-room-rug': { v: ['43486647582875'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Oscar_20Rugs_201azx_20_46_5B5_5D.jpg' },
    'faded-distressed-grey-geometric-pattern-rug': { v: ['43486643355803'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Oscar-Anise-Grey-Close-Up---Grey-Oriental-Soft-Living-Room-Rug_5B4_5D.jpg' },
    'fern-green-shaggy-rug': { v: ['43486652235931'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Vancouver-Fern-Green-Donnas-2_zps2o6a8z3h_5B4_5D.jpg' },
    'rich-brown-washable-distressed-boho-rug': { v: ['43484948234395'], im: 'https://www.kukoonrugs.com/cdn/shop/files/renuu-Caris_20Multi-03324_5B5_5D.jpg' },
    'washable-distressed-green-medallion-rug': { h: 'washable-green-medallion-runner-rug' },
    'geometric-blue-and-grey-rug': { v: ['43485413867675'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3077-BS22-Marketplace-Shotjpg_5B3_5D.jpg' },
    'light-brown-mottled-shaggy-living-room-rug-murano': { v: ['43486636343451'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-murano-biege-4266_5B5_5D.jpg' },
    'modern-blue-distressed-abstract-living-room-rug': { v: ['43484985458843'], im: 'https://www.kukoonrugs.com/cdn/shop/files/astia-blue-9038_5B4_5D.jpg' },
    'modern-gold-abstract-distressed-living-room-rugs': { v: ['43485293969563'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Gemini_Generated_Image_rd0s06rd0s06rd0s.png' },
    'modern-green-abstract-distressed-rugs': { v: ['43485295247515'], im: 'https://www.kukoonrugs.com/cdn/shop/files/tweed-olive-green-2_5B5_5D.jpg' },
    'modern-yellow-ochre-distressed-large-living-room-rugs': { v: ['56588762317181'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-enzo-new-designs-gold-grey-1_5B2_5D.jpg' },
    'mottled-dark-green-shaggy-rug-for-living-room-murano': { v: ['43486638047387'], im: 'https://www.kukoonrugs.com/cdn/shop/files/Murano-Dark-Green-Close-Up---Mottled-Shaggy-Living-Room-Rug_5B4_5D.jpg' },
    'natural-toned-diamond-living-room-rug': { v: ['43487141593243'], im: 'https://www.kukoonrugs.com/cdn/shop/files/warner-natural-3586_5B1_5D.jpg' },
    'navy-mottled-striped-shaggy-living-room-rug-murano': { v: ['43486639587483'], im: 'https://www.kukoonrugs.com/cdn/shop/files/murano-navy-stripe-4093_5B2_5D.jpg' },
    'ochre-grey-fractured-rug': { v: ['43832238014619'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3606-gb15-9.jpg' },
    'ornate-soft-grey-distressed-medallion-living-room-rug': { v: ['43484987621531'], im: 'https://www.kukoonrugs.com/cdn/shop/files/meredith-multi-9072_5B5_5D.jpg' },
    'pink-grey-bordered-framed-living-room-rug': { v: ['43485417963675'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3642-GB43-Insta-Customer-Pic-3_5B4_5D.jpg' },
    'pink-grey-distressed-worn-look-living-room-rug': { v: ['43485417210011'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3639-GB33_Milan-Instagram-Customer-Pic_5B2_5D.jpg' },
    'pink-grey-modern-area-rug': { h: 'pink-grey-modern-geometric-runner-rug' },
    'pink-grey-traditional-patchwork-living-room-rug': { v: ['43485409378459'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kukoon-1572-gb33-4632jpg_5B2_5D.jpg' },
    'premium-cosy-ochre-striped-shaggy-rug-murano': { v: ['43486642372763'], im: 'https://www.kukoonrugs.com/cdn/shop/files/murano-ochre-stripe-3847_5B2_5D.jpg' },
    'soft-abstract-shaggy-rug-cherish': { v: ['55533967507837'], im: 'https://www.kukoonrugs.com/cdn/shop/files/travellercherishmulti_AbstractShaggyRunnerRoomMarketplaceHallRug_2.jpg' },
    'soft-mottled-brown-shaggy-area-rug-camberley': { v: ['43486658298011'], im: 'https://www.kukoonrugs.com/cdn/shop/files/latte-0133_5B5_5D.jpg' },
    'soft-mottled-grey-shaggy-area-rug-camberley': { v: ['43486659477659'], im: 'https://www.kukoonrugs.com/cdn/shop/files/slate-07155_5B5_5D.jpg' },
    'soft-mottled-light-blue-shaggy-area-rug-camberley': { v: ['43486657642651'], im: 'https://www.kukoonrugs.com/cdn/shop/files/confetti-07200_5B5_5D.jpg' },
    'soft-mottled-silver-shaggy-area-rug-camberley': { v: ['43486659248283'], im: 'https://www.kukoonrugs.com/cdn/shop/files/silver-0756_5B2_5D.jpg' },
    'soft-natural-blue-aztec-area-rug': { v: ['43487140642971'], im: 'https://www.kukoonrugs.com/cdn/shop/files/kemp-blue-3123_5B1_5D.jpg' },
    'teal-blue-cloudscape-living-room-rug': { v: ['43491322331291'], im: 'https://www.kukoonrugs.com/cdn/shop/files/times-blue-9607_5B5_5D.jpg' },
    'yellow-grey-distressed-worn-look-living-room-rug': { v: ['43485416980635'], im: 'https://www.kukoonrugs.com/cdn/shop/files/7_20_3_5B2_5D.jpg' },
    'yellow-grey-geometric-triangle-bedroom-rug': { v: ['43485412229275'], im: 'https://www.kukoonrugs.com/cdn/shop/files/2517-gb44-8_5B4_5D.jpg' },
    'yellow-trellis-living-room-area-rug': { v: ['43485415014555'], im: 'https://www.kukoonrugs.com/cdn/shop/files/3512-gb11-3.jpg' },
    'vintage-grey-washed-effect-living-room-rug': { h: 'vintage-grey-washed-effect-bedroom-rug-ludlow', v: ['43484986474651'] }
  };
  // a runner-shaped copy of the rug for the card: its name says runner (so it
  // counts as one), the checked photo, and only the runner size(s) to pick
  function runnerSize(me, index) {
    var r = me && RUNNER_SIZE[me.h];
    if (!r) return null;
    if (r.h) {
      // another listing is this rug's runner
      var src = null;
      for (var j = 0; j < (index || []).length; j++) if (index[j].h === r.h) { src = index[j]; break; }
      if (!src || src.oos || src.hide) return null;
      if (!r.v && /runner/i.test(src.t || '')) return src;
      me = src; r = { v: r.v || [String(src.vid || '')], im: r.im || (src.im || [])[0] };
    }
    var t = me.t || '', i = t.lastIndexOf(' - ');
    var base = (i === -1 ? t : t.slice(0, i)).replace(/\b(area |living room |bedroom )?rugs?\b/ig, '').replace(/\s+/g, ' ').trim();
    var o = {}; for (var k in me) o[k] = me[k];
    o.t = base + ' Runner' + (i === -1 ? '' : t.slice(i));
    o.im = [r.im]; o.ri = ''; o.only = r.v; o.vid = r.v[0];
    o.tg = (me.tg || []).filter(function (g) { return g !== 'Doormat' && g !== 'Circle' && g !== 'Cushion'; });
    return o;
  }
  // the other way round (20 Oct 2026, Jack): they picked the runner size, so the
  // card is the same rug in its rug sizes - main photo, only the non-runner sizes
  function rugSize(me) {
    if (!me || !me.vv) return null;
    var v = [];
    for (var k in me.vv) if (!/runner/i.test(k) && me.vv[k]) v.push(String(me.vv[k]));
    if (!v.length) return null;
    var o = {}; for (var x in me) o[x] = me[x];
    o.t = String(me.t || '').replace(/s*runner/ig, '');
    o.tg = (me.tg || []).filter(function (g) { return g !== 'Runner Rugs'; });
    o.only = v; o.vid = v[0]; o.ri = ''; o.own = 'rug';
    return o;
  }
  var CHOSEN = '';   // the size title just added (afterAdd)
  function pick(index, handle, inCart) {
    var out = pick0(index, handle, inCart), want = colourRunner(handle, CHOSEN);
    // they just picked a runner size: no runner offered, as the basket already does (20 Oct 2026)
    if (/runner/i.test(CHOSEN)) {
      out = out.filter(function (x) { return kind(x.p) !== 'runner'; });
      var me0 = null;
      for (var q = 0; q < index.length; q++) if (index[q].h === handle) { me0 = index[q]; break; }
      var rs = !out.some(function (x) { return kind(x.p) === 'rug'; }) && rugSize(me0);
      if (rs) out = [{ p: rs, why: 'set' }].concat(out).slice(0, MAX);
    }
    if (want === null) {
      var me = null;
      for (var j = 0; j < index.length; j++) if (index[j].h === handle) { me = index[j]; break; }
      var own = runnerSize(me, index);
      if (own && !/runner/i.test(CHOSEN) && !out.some(function (x) { return kind(x.p) === 'runner'; }))
        out = out.slice(0, MAX - 1).concat([{ p: own, why: 'set' }]);
      return out;
    }
    var at = -1;
    out = out.filter(function (x, i) { if (kind(x.p) !== 'runner') return true; if (at < 0) at = i; return false; });
    var r = null;
    if (want) for (var i = 0; i < index.length; i++) if (index[i].h === want) { r = index[i]; break; }
    if (r && !r.oos && !r.hide && !inCart[r.h]) out.splice(at < 0 ? out.length : at, 0, { p: r, why: 'set' });
    return out.slice(0, MAX);
  }
  function pick0(index, handle, inCart) {
    var me = null;
    for (var i = 0; i < index.length; i++) if (index[i].h === handle) { me = index[i]; break; }
    if (!me) return [];
    var mine = kind(me), ok = function (p) {
      return p.h !== handle && !p.oos && !p.hide && !inCart[p.h] && !NEVER[p.h] && kind(p) !== 'underlay' && kind(p) !== 'stair';
    };
    var out = [], seen = {};
    var ps = normSet(me.ps);
    if (ps) {
      var order = ORDER[mine] || ORDER.rug;
      var set = index.filter(function (p) {
        if (!ok(p) || !sameSet(normSet(p.ps), ps)) return false;
        var k = kind(p);
        // a rug never offers another rug: in a set they are other colours
        // (a circle never offers a circle either: in the index the same rug is
        // often listed twice, e.g. "...circle-rug" and "...circle-nursery-rug")
        return !(k === mine && (k === 'rug' || k === 'runner' || k === 'circle'));
      });
      var myName = rangeName(me).toLowerCase(), byKind = {};
      set.forEach(function (p) { (byKind[kind(p)] = byKind[kind(p)] || []).push(p); });
      set = [];
      Object.keys(byKind).forEach(function (k) {
        var list = byKind[k];
        var same = list.filter(function (p) { return myName && rangeName(p).toLowerCase() === myName; });
        var names = {}; list.forEach(function (p) { names[rangeName(p).toLowerCase()] = 1; });
        if (same.length) list = same;
        else if (Object.keys(names).length > 1) {
          list = list.map(function (p) { return { p: p, sc: colourScore(me, p) }; })
            .sort(function (a, b) { return b.sc - a.sc || (b.p.s || 0) - (a.p.s || 0); })
            .slice(0, 1).map(function (x) { return x.p; });
        }
        set = set.concat(list);
      });
      set.forEach(function (p) { if (!seen[p.h]) { out.push({ p: p, why: 'set' }); seen[p.h] = 1; } });
    }
    // a natural-fibre rug: the natural pieces its set does not have - a jute
    // doormat, a jute circle, a jute runner - best seller first, nearest
    // colour first among those
    var natural = isNatural(me);
    if (natural && FILLERS) {
      var haveKind = {}; haveKind[mine] = 1;
      out.forEach(function (x) { haveKind[kind(x.p)] = 1; });
      NATURAL_KINDS.forEach(function (k) {
        if (haveKind[k]) return;
        var best = index.filter(function (p) {
          // a doormat has to be a plain one: most coir mats are printed
          // novelty mats ("Dia Duit", "Hello Fox"), which match nothing
          return ok(p) && !seen[p.h] && kind(p) === k && isNatural(p) && (p.s || 0) >= NATURAL_MIN_SOLD &&
            (k !== 'doormat' || /\bjute\b/i.test(p.t || ''));
        }).sort(function (a, b) {
          return colourScore(me, b) - colourScore(me, a) || (b.s || 0) - (a.s || 0);
        })[0];
        if (best) { out.push({ p: best, why: 'material' }); seen[best.h] = 1; }
      });
    }
    // no cushion in the set: one that plainly matches the rug's main colour.
    // Never for natural fibre - no cushion we sell is jute, and a beige
    // cushion beside a brown jute rug matches nothing (Jack, 30 Sep)
    var haveCushion = out.some(function (x) { return kind(x.p) === 'cushion'; });
    var wanted = CUSHION_FOR[String(me.co || '').split(/[,/|]/)[0].trim()];
    if (FILLERS && mine !== 'cushion' && !haveCushion && wanted && !natural) {
      // only a proven one: a cushion nobody buys or has reviewed, offered
      // first, makes the whole popup look like filler (1 Oct 2026)
      var best = index.filter(function (p) {
        return ok(p) && kind(p) === 'cushion' && !seen[p.h] && wanted.indexOf(p.co) !== -1 &&
          (p.s || 0) >= CUSHION_MIN_SOLD && (p.rc || 0) >= 1;
      }).sort(function (a, b) {
        return wanted.indexOf(a.co) - wanted.indexOf(b.co) || (b.s || 0) - (a.s || 0);
      })[0];
      if (best) { out.push({ p: best, why: 'colour' }); seen[best.h] = 1; }
    }
    // one ranking: the range's own pieces in ORDER, cushions always last (a
    // premium range should lead with itself), then the cap. rankForTier()
    // re-orders this once live prices are known.
    var order = ORDER[mine] || ORDER.rug;
    out.sort(function (a, b) {
      var ca = kind(a.p) === 'cushion', cb = kind(b.p) === 'cushion';
      if (ca !== cb) return ca ? 1 : -1;
      // the "runner" group: on a rug or circle the range's runner leads
      if (LEAD === 'runner' && (mine === 'rug' || mine === 'circle')) {
        var ra = kind(a.p) === 'runner', rb = kind(b.p) === 'runner';
        if (ra !== rb) return ra ? -1 : 1;
      }
      return order.indexOf(kind(a.p)) - order.indexOf(kind(b.p)) || (b.p.s || 0) - (a.p.s || 0);
    });
    if (out.length && out.every(function (x) { return kind(x.p) === 'cushion'; })) return [];
    return out.slice(0, MAX);
  }

  /* The discount decides the order (1 Oct 2026). Short of the threshold, the
     first thing offered is the piece that gets them over it for the least
     money - in the size that does it - then the rest of the range, then
     cushions. Already over it: the easy yes first, as pick() ordered. */
  // what GOBIG20 counts - not underlay, cushions or doormats (theme.liquid, 27 Oct 2026)
  function tierBase(cart) {
    if (window.KukoonTierBase) return window.KukoonTierBase(cart);
    return ((cart && cart.total_price) || 0) / 100;
  }
  function liveVariants(v) {
    return ((v && v.variants && v.variants.nodes) || []).filter(function (n) { return n.availableForSale; })
      .sort(function (a, b) { return Number(a.price.amount) - Number(b.price.amount); });
  }
  var INDEX_ROWS = null;
  function index0(h) { if (!INDEX_ROWS) return null; for (var i = 0; i < INDEX_ROWS.length; i++) if (INDEX_ROWS[i].h === h) return INDEX_ROWS[i]; return null; }
  function rankForTier(items, liveData, cart) {
    var goal = TIER[(cart && cart.currency) || CURRENCY];
    var left = goal ? goal - tierBase(cart) : 0;
    items.forEach(function (x, i) {
      x.base = i;
      var vs = liveVariants(liveData[x.p.h]);
      var over = left > 0 ? vs.filter(function (n) { return Number(n.price.amount) >= left; })[0] : null;
      x.pref = over ? vid(over.id) : '';          // the size that crosses the line
      x.reach = over ? Number(over.price.amount) : Infinity;
    });
    if (left > 0) items.sort(function (a, b) {
      var ca = kind(a.p) === 'cushion', cb = kind(b.p) === 'cushion';
      if (ca !== cb) return ca ? 1 : -1;            // cushions last, still
      var ra = isFinite(a.reach), rb = isFinite(b.reach);
      if (ra !== rb) return ra ? -1 : 1;             // what gets them there first
      if (ra && rb && a.reach !== b.reach) return a.reach - b.reach;   // ...cheapest way there first
      return a.base - b.base;
    });
    if (LEAD === 'runner' && left > 0) {
      var r = items.filter(function (x) { return kind(x.p) === 'runner'; })[0];
      var src = state.source && index0(state.source);
      if (r && src && (kind(src) === 'rug' || kind(src) === 'circle')) { items.splice(items.indexOf(r), 1); items.unshift(r); }
    }
    return items;
  }

  /* ------------------------------------------------------- live data */
  function live(handles) {
    if (!S.storefrontToken || !handles.length) return Promise.resolve({});
    var country = /^[A-Z]{2}$/.test(S.country || '') ? S.country : 'GB';
    var parts = handles.map(function (h, i) {
      return 'a' + i + ': product(handle: ' + JSON.stringify(h) + ') { availableForSale ' +
        'variants(first: 40) { nodes { id title availableForSale price { amount currencyCode } ' +
        'compareAtPrice { amount } } } }';
    });
    return fetch(S.storefrontUrl || '/api/2025-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': S.storefrontToken },
      body: JSON.stringify({ query: 'query @inContext(country: ' + country + ') {' + parts.join(' ') + '}' }),
    }).then(function (r) { return r.json(); }).then(function (j) {
      var out = {};
      handles.forEach(function (h, i) { out[h] = j && j.data && j.data['a' + i]; });
      return out;
    }).catch(function () { return {}; });
  }

  var CURRENCY = S.currencyCode || 'GBP';
  function money(amount, code) {
    try {
      var n = Number(amount);
      // en-IE for Ireland, en-GB for the UK: the market's own formatting
      var loc = /^[a-z]{2}$/i.test(S.locale || '') && /^[A-Z]{2}$/.test(S.country || '')
        ? S.locale + '-' + S.country : (S.locale || 'en-GB');
      return new Intl.NumberFormat(loc, {
        style: 'currency', currency: code || CURRENCY,
        minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2,
      }).format(n);
    } catch (e) { return '£' + Number(amount).toFixed(2); }
  }
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var img = function (u, w) { return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; };
  var cap = function (s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
  var vid = function (gid) { return String(gid || '').replace(/\D/g, ''); };

  /* ----------------------------------------------------------- popup */
  var state = { source: '', items: [], cart: null, added: 0 };
  var root = null, lastFocus = null;

  /* One event per thing that happens, read by Upsell Radar:
       term        "set:" + the product that opened the popup
       refinement  shown | offered | added | added_all | checkout | code_copied | closed | keep_shopping
       handle      the product it happened to (for shown: every product offered)
       position    its place in the popup, 1-4 - or, for shown and checkout,
                   the basket total in whole pounds/euros at that moment
       surface     set-overhead | set-room  (the A/B group)
       filters     market: country|currency, e.g. "IE|EUR"
       results     how many products were offered */
  function track(action, handle, position) {
    try {
      if (window.kukoonSearchLog && state.source) {
        var cart = state.cart || {};
        var basket = Math.round((cart.total_price || 0) / 100);
        window.kukoonSearchLog('set', { term: 'set:' + state.source, refinement: action,
          handle: handle || '',
          position: (action === 'shown' || action === 'checkout') ? basket : (position || null),
          surface: EVGROUP, results: state.items.length,
          filters: (S.country || '') + '|' + (cart.currency || CURRENCY) });
      }
    } catch (e) {}
  }

  function title(x, range) {
    var p = x.p, k = kind(p);
    // the name a shopper would use: "Zoe runner", not "Flatwoven Washable..."
    // The heading already says "Finish the Zoe look", so a card in the set
    // just says what it is - "Doormat", "Kitchen mat", "Circle". Short enough
    // never to be cut off, so every card's name is one clean line.
    // the range name stays: "William Morris runner" sells, "Runner" does not
    if (x.why === 'set') return range ? range + ' ' + NOUN[k] : cap(NOUN[k]);
    // a natural piece from another range: "Jute doormat", "Jute circle"
    if (x.why === 'material') {
      var m = (/^(jute|coir|sisal|seagrass)/i.exec(p.mat || '') || [])[1] || 'Jute';
      if (/^coir$/i.test(m) && /jute/i.test(p.t || '')) m = 'Jute';
      return cap(m.toLowerCase()) + ' ' + NOUN[k];
    }
    // a colour-matched cushion: its colour, e.g. "Teal cushion"
    if (k === 'cushion') {
      var c = p.t.replace(/\b(distressed|vintage|bold|cushion|cover)\b/gi, '').replace(/\s+/g, ' ').trim();
      return (c ? c + ' cushion' : 'Cushion').replace(/^./, function (m) { return m.toUpperCase(); });
    }
    return cap(NOUN[k]);
  }

  function stars(p) {
    // Both lines are drawn - the real rating (if it has reviews) and the
    // product's headline feature ("Machine Washable") - and the ROW picks one
    // for every card (drawArrows -> data-rate): stars when every piece has
    // reviews, features when any is missing them, so a row never mixes ticks
    // and stars. Never a made-up rating - a review count must be real.
    var f = (p.ft || [])[0], has = p.rc && p.r, out = '';
    if (has) out += '<span class="kset-stars kset-r" aria-label="Rated ' + Number(p.r).toFixed(1) + ' out of 5 from ' + p.rc +
      ' reviews"><span aria-hidden="true">&#9733;</span> ' + Number(p.r).toFixed(1) +
      ' <span class="kset-rc">(' + p.rc + ')</span></span>';
    if (f) out += '<span class="kset-stars kset-feat kset-f">' + esc(f) + '</span>';
    return out || '<span class="kset-stars">&nbsp;</span>';
  }
  function priceHtml(a, w, c) {
    return (w ? '<s>' + esc(money(w, c)) + '</s> ' : '') + '<b>' + esc(money(a, c)) + '</b>';
  }

  function card(x, v, i, range) {
    var p = x.p;
    var vars = ((v && v.variants && v.variants.nodes) || []).filter(function (n) { return n.availableForSale; });
    if (p.only) { vars = vars.filter(function (n) { return p.only.indexOf(vid(n.id)) !== -1; }); if (!vars.length) return ''; }
    if (v && !vars.length) return '';
    // cheapest size first: a runner at £35 beats one at £70 as a first offer
    vars.sort(function (a, b) { return Number(a.price.amount) - Number(b.price.amount); });
    var first = vars[0];
    // no live price: the list's price is in pounds, so it is only usable on
    // the UK market - anywhere else the card is left out rather than showing
    // a euro shopper a pound price
    if (!first && CURRENCY !== 'GBP') return '';
    if (x.pref) vars.forEach(function (n) { if (vid(n.id) === x.pref) first = n; });
    var amount = first ? Number(first.price.amount) : Number(p.min || 0);
    var code = first ? first.price.currencyCode : CURRENCY;
    var was = first && first.compareAtPrice && Number(first.compareAtPrice.amount) > amount ? Number(first.compareAtPrice.amount) : 0;
    var url = (S.productUrlBase || '/products/') + p.h;
    var name = title(x, range);
    // the one-line fallback: if any name in the row would wrap, the set pieces
    // all drop the range (the heading already names it) - drawArrows decides
    var short = x.why === 'set' && range ? cap(NOUN[kind(p)]) : '';
    // no live sizes (prices did not load): the product's cheapest, as one option
    if (!vars.length) vars = [{ id: String(p.vid || ''), title: 'One size',
      price: { amount: String(amount), currencyCode: code }, compareAtPrice: was ? { amount: String(was) } : null }];
    // always a dropdown, even for one size: every card the same shape, so the
    // names, stars, prices and Add buttons line up across the row
    var sizeHtml = true
      ? '<label class="kset-size"><span class="kset-sr">Size for ' + esc(name) + '</span>' +
          '<select data-v>' + vars.map(function (n) {
            var a = Number(n.price.amount), w = n.compareAtPrice ? Number(n.compareAtPrice.amount) : 0;
            return '<option value="' + esc(vid(n.id)) + '"' + (x.pref && vid(n.id) === x.pref ? ' selected' : '') +
              ' data-a="' + a + '" data-w="' + (w > a ? w : 0) + '" data-c="' +
              esc(n.price.currencyCode) + '">' + esc(n.title === 'Default Title' ? 'One size' : n.title) +
              ' &middot; ' + esc(money(a, n.price.currencyCode)) + '</option>';
          }).join('') + '</select></label>'
      : '<input type="hidden" data-v value="' + esc(first ? vid(first.id) : (p.vid || '')) + '" data-a="' + amount +
          '" data-w="' + was + '" data-c="' + esc(code) + '">' +
        (first && first.title !== 'Default Title' ? '<span class="kset-one">' + esc(first.title) + '</span>' : '');
    return '<li class="kset-card" data-h="' + esc(p.h) + '" data-i="' + i + '"' + (p.only ? ' data-own="' + (p.own || 'own') + '"' : '') + '>' +
      '<a class="kset-img' + (AB === 'room' && p.ri ? ' is-room' : '') + '" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
        (was ? '<span class="kset-badge">Sale</span>' : '') +
        // room group: the room shot where the product has one, else the same
        // overhead shot as everyone - so a missing photo never shows a blank
        '<img src="' + esc(img(AB === 'room' && p.ri ? p.ri : (p.im || [])[0], 500)) + '" alt="" loading="lazy"></a>' +
      '<a class="kset-name" href="' + esc(url) + '" title="' + esc(p.t) + '"' + (short ? ' data-short="' + esc(short) + '"' : '') + '>' + esc(name) + '</a>' +
      (x.why === 'set' && range ? '<span class="kset-match">Made to match your ' + esc(range) + ' rug</span>' : '') +
      stars(p) +
      '<span class="kset-price" data-price>' + priceHtml(amount, was, code) + '</span>' +
      sizeHtml +
      '<span class="kset-hint" data-hint hidden></span>' +
      '<span class="kset-sp" aria-hidden="true"></span>' +
      '<button type="button" class="kset-add' + (i === 0 ? ' is-pick' : '') + '" data-add>+ Add</button>' +
      '</li>';
  }
  var chosen = function (li) {
    var v = li.querySelector('[data-v]'); if (!v) return null;
    var o = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
    return { id: v.value, a: Number(o.dataset.a || 0), w: Number(o.dataset.w || 0), c: o.dataset.c || CURRENCY };
  };

  function drawProgress() {
    if (!root) return;
    var cart = state.cart || {}, box = root.querySelector('[data-tier]');
    var goal = TIER[cart.currency || CURRENCY];
    if (!box) return;
    if (!goal) { box.hidden = true; return; }
    var total = tierBase(cart), left = Math.max(0, goal - total);
    var pct = Math.max(4, Math.min(100, Math.round(total / goal * 100)));
    box.hidden = false;
    box.classList.toggle('is-done', left <= 0);
    root.querySelector('[data-fill]').style.width = pct + '%';
    root.querySelector('[data-bar]').setAttribute('aria-valuenow', pct);
    // no Copy button any more: the basket has its own code box, where they
    // type it and press Apply themselves (Jack, 2 Oct 2026)
    var chip = CODE ? '<span class="kset-code"><span>' + esc(CODE) + '</span></span>' : '';
    /* Over the line already (61% of popups) the code is the same one the hero
       and the announcement bar show - repeating it here only crowded the
       pieces. It stays for those still short of it (12 Oct 2026). */
    root.querySelector('[data-tier-text]').innerHTML = left <= 0
      ? '<b>Unlocked: ' + esc(TIER_LABEL) + '</b>'
      : 'You&rsquo;re <b>' + esc(money(left, cart.currency)) + '</b> away from ' + esc(TIER_LABEL) +
        (CODE ? '<span class="kset-code-line">then use ' + chip + ' in your basket</span>' : '');
    // on each card still to add: does this one alone get them there?
    root.querySelectorAll('.kset-card').forEach(function (li) {
      var h = li.querySelector('[data-hint]'), c = chosen(li);
      if (!h || h.dataset.err) return;
      var show = left > 0 && c && !li.classList.contains('is-added') && c.a >= left;
      // the underlay card keeps its own line ('Sized for your Dusk rug') when it does not get them there
      var def = h.getAttribute('data-def') || '';
      h.hidden = !show && !def;
      h.textContent = show ? 'This gets you there' : def;   // the bar above says what 'there' is
    });
  }
  function isUnlocked() {
    var cart = state.cart || {}, goal = TIER[cart.currency || CURRENCY];
    return !!goal && tierBase(cart) >= goal;
  }
  function copyCode(btn) {
    var done = function () {
      var l = btn && btn.querySelector('[data-code-lbl]');
      if (l) { l.textContent = 'Copied ✓'; setTimeout(function () { if (l.isConnected) l.textContent = 'Copy'; }, 2200); }
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(done, function () {});
      else {
        var ta = document.createElement('textarea'); ta.value = CODE; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); ta.remove(); done();
      }
    } catch (e) {}
  }
  // "Add all" was removed (1 Oct 2026): nobody doubles a £200 basket in one
  // tap, and a button nobody presses only competes with the ones they do
  function drawAddAll() {}

  // the arrows either side of the row: shown only when there is more that way
  function drawArrows() {
    if (!root) return;
    var list = root.querySelector('.kset-list'), prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (!list || !prev || !next) return;
    // every name on one line: drop the reserved second line (no gap under it)
    var names = [].slice.call(list.querySelectorAll('.kset-name'));
    list.classList.add('short-names');           // measure without the reserved line
    var lh = names[0] ? parseFloat(getComputedStyle(names[0]).lineHeight) || 20 : 20;
    var wraps = function () { return names.some(function (n) { return n.scrollHeight > lh * 1.5; }); };
    // "William Morris kitchen mat" wraps: every set piece becomes "Kitchen mat",
    // "Doormat", "Runner" so the whole row stays one line, all alike
    if (names.length > 2 && wraps()) names.forEach(function (n) { if (n.dataset.short) n.textContent = n.dataset.short; });
    if (!names.length || wraps()) list.classList.remove('short-names');
    // stars for every card, or features for every card - never mixed
    var cards = [].slice.call(list.querySelectorAll('.kset-card'));
    var allR = cards.every(function (c) { return c.querySelector('.kset-r'); });
    var allF = cards.every(function (c) { return c.querySelector('.kset-f'); });
    list.setAttribute('data-rate', allR ? 'stars' : allF ? 'feat' : 'mixed');
    // level with the middle of the photos, whatever size the cards are
    var im = list.querySelector('.kset-img');
    if (im) prev.style.top = next.style.top = (im.offsetTop + im.offsetHeight / 2) + 'px';
    // one or two cards all fit - no arrows (iPhone measured a sliver wider and showed
    // one that did nothing, Jack 15 Oct 2026)
    var more = Number(list.getAttribute("data-n")) > 2 && list.scrollWidth - list.clientWidth > 4;
    prev.hidden = !more || list.scrollLeft <= 4;
    next.hidden = !more || list.scrollLeft >= list.scrollWidth - list.clientWidth - 4;
  }
  function slide(dir) {
    var list = root && root.querySelector('.kset-list'); if (!list) return;
    var card = list.querySelector('.kset-card');
    var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 16) : list.clientWidth;
    list.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function addedRow(cart, handle, me, range) {
    var mine = (cart.items || []).filter(function (i) { return i.handle === handle; });
    // the size just added if we know it; otherwise this product's line
    var it = mine.filter(function (i) { return state.variant && String(i.variant_id) === state.variant; })[0] || mine[0];
    // the short name again: "Zoe rug", not the full listing title
    var nm = it ? (range && me ? range + ' ' + NOUN[kind(me)] : it.product_title) : '';
    if (!it) return '<p class="kset-added-row"><span class="kset-added-lbl"><span class="kset-tick" aria-hidden="true">&#10003;</span> Added to your basket</span></p>';
    return '<div class="kset-added-row">' +
      (it.image ? '<img src="' + esc(img(it.image, 120)) + '" alt="">' : '') +
      '<div><span class="kset-added-lbl"><span class="kset-tick" aria-hidden="true">&#10003;</span> Added to your basket</span>' +
      '<span class="kset-added-name">' + esc(nm) +
      (it.variant_title ? ' <span>&middot; ' + esc(it.variant_title) + '</span>' : '') + '</span></div></div>';
  }

  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
  }
  function close(how) {
    if (!root) return;
    var r = root; root = null;
    r.classList.remove('is-open');
    document.documentElement.classList.remove('kset-lock');
    setTimeout(function () { r.remove(); }, 240);
    if (how === 'basket') openDrawer();
    else if (how !== 'checkout') {
      track(how === 'keep' ? 'keep_shopping' : 'closed');
      if (!state.added) {
        try {
          var dm = JSON.parse(sessionStorage.getItem(DISMISS) || '{}');
          if (typeof dm !== 'object' || !dm) dm = {};
          if (state.source) dm[state.source] = 1;
          sessionStorage.setItem(DISMISS, JSON.stringify(dm));
        } catch (e) {}
      }
      // "No thanks" stays on the page; closing any other way shows the basket,
      // the way the site always has after an add
      if (how === 'keep') document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      else openDrawer();
    }
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }

  function open(items, liveData, cart, me) {
    if (root) { root.remove(); root = null; }
    lastFocus = document.activeElement;
    var range = rangeName(me);
    if (range && (range.length > 18 || /\d/.test(range))) range = '';
    var cards = items.map(function (x, i) { return x.why === 'underlay' ? underlayCard(x, i, range) : card(x, liveData[x.p.h], i, range); }).filter(Boolean);
    if (!cards.length) return false;
    var setItems = items.filter(function (x) { return x.why === 'set'; });
    var heading = setItems.length ? (range ? 'Finish the ' + range + ' look' : 'Complete the set') : 'Goes with your rug';
    state.items = items; state.cart = cart; state.added = 0;
    root = document.createElement('div');
    root.className = 'kset';
    root.innerHTML =
      '<div class="kset-back" data-close></div>' +
      '<div class="kset-box" role="dialog" aria-modal="true" aria-labelledby="kset-h" tabindex="-1">' +
        '<button type="button" class="kset-x" data-close aria-label="Close">&times;</button>' +
        addedRow(cart, state.source, me, range) +
        '<h2 id="kset-h">' + esc(heading) + '</h2>' +
        '<div class="kset-tier" data-tier hidden>' +
          '<p class="kset-tier-text" data-tier-text aria-live="polite"></p>' +
          '<div class="kset-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" data-bar><span data-fill></span></div>' +
        '</div>' +
        '<div class="kset-rail">' +
          '<button type="button" class="kset-arrow kset-prev" data-prev aria-label="Previous products" hidden>&lsaquo;</button>' +
          '<ul class="kset-list' + (cards.length === 1 ? ' is-solo' : '') + '" data-n="' + cards.length + '">' + cards.join('') + '</ul>' +
          '<button type="button" class="kset-arrow kset-next" data-next aria-label="More products" hidden>&rsaquo;</button>' +
        '</div>' +
        '<div class="kset-foot">' +
          // to the basket, not checkout (Jack, 2 Oct 2026): checkout skipped the
          // underlay offer, Meet the A-listers and the discount code box
          '<button type="button" class="kset-checkout" data-checkout>View basket <span aria-hidden="true">&rarr;</span></button>' +
          '<button type="button" class="kset-keep" data-keep>No thanks, keep shopping</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    document.documentElement.classList.add('kset-lock');
    drawProgress();
    var list = root.querySelector('.kset-list');
    if (list) list.addEventListener('scroll', drawArrows, { passive: true });
    requestAnimationFrame(function () { if (root) { root.classList.add('is-open'); drawArrows(); } });
    setTimeout(drawArrows, 400);   // again once the photos have given the cards their size
    var box = root.querySelector('.kset-box'); if (box) box.focus();
    // one "shown" per popup, then one "offered" per product in it (a handle
    // list would not fit the log's 150-character field)
    track('shown', '');
    items.forEach(function (x, i) { track('offered', x.p.h, i + 1); });
    return true;
  }

  function add(lis, btn) {
    var lines = [];
    lis.forEach(function (li) {
      var c = chosen(li); if (!c || !c.id) return;
      var hv = li.querySelector('input[data-ul-for]');
      // hidden line property (checkout hides "_" ones): lets the order history
      // count revenue from the popup, per A/B group - as _search does for search
      var props = { _upsell: GROUP };
      if (hv) props._underlay_for = hv.getAttribute('data-ul-for');   // kept with its rug in the basket
      // the rug's own runner size (20 Oct 2026): counted on its own, the group stays as it is
      if (li.hasAttribute('data-own')) props._runner_size = li.getAttribute('data-own') || 'own';
      lines.push({ id: Number(c.id), quantity: hv ? Number(hv.getAttribute('data-ul-qty') || 1) : 1, properties: props });
    });
    if (!lines.length) return;
    var label = btn.innerHTML;
    btn.disabled = true; btn.textContent = 'Adding…';
    lis.forEach(function (li) { li.classList.add('is-busy'); });
    fetch(route('cart_add_url', '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines }),
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      lis.forEach(function (li) {
        li.classList.remove('is-busy'); li.classList.add('is-added');
        var b = li.querySelector('[data-add]');
        b.disabled = true; b.innerHTML = '&#10003; Added';
        var sel = li.querySelector('select'); if (sel) sel.disabled = true;
        track(lis.length > 1 ? 'added_all' : 'added', li.dataset.h, Number(li.dataset.i) + 1);
      });
      state.added += lis.length;
      // the filled "pick" button moves to the next card not yet added
      if (lis.some(function (li) { return li.querySelector('.kset-add.is-pick'); })) {
        lis.forEach(function (li) { var b2 = li.querySelector('.kset-add'); if (b2) b2.classList.remove('is-pick'); });
        var nextCard = root && root.querySelector('.kset-card:not(.is-added) .kset-add');
        if (nextCard) nextCard.classList.add('is-pick');
      }
      if (btn.hasAttribute('data-addall')) btn.hidden = true;
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
      return getCart().then(function (c) { state.cart = c; drawProgress(); drawAddAll(); });
    }).catch(function () {
      lis.forEach(function (li) { li.classList.remove('is-busy'); });
      btn.disabled = false; btn.innerHTML = label;
      var h = lis[0] && lis[0].querySelector('[data-hint]');
      if (h) { h.hidden = false; h.dataset.err = '1'; h.textContent = 'Couldn’t add that — try again'; }
    });
  }

  document.addEventListener('click', function (e) {
    if (!root) return;
    var t = e.target;
    if (t.closest('[data-close]')) { e.preventDefault(); close('x'); return; }
    if (t.closest('[data-keep]')) { e.preventDefault(); close('keep'); return; }
    if (t.closest('[data-checkout]')) {
      e.preventDefault(); track('checkout');
      // unlocked: the code is on their clipboard, ready to paste at checkout
      close('basket');
      return;
    }
    var cb = t.closest('[data-code]');
    if (cb) { e.preventDefault(); copyCode(cb); track('code_copied'); return; }
    if (t.closest('[data-prev]')) { slide(-1); return; }
    if (t.closest('[data-next]')) { slide(1); return; }
    var one = t.closest('[data-add]');
    if (one && !one.disabled) add([one.closest('.kset-card')], one);
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.kset select[data-v]');
    if (!sel) return;
    var li = sel.closest('.kset-card'), c = chosen(li), pr = li.querySelector('[data-price]');
    if (c && pr) pr.innerHTML = priceHtml(c.a, c.w, c.c);
    drawAddAll(); drawProgress();
  });
  // keyboard: Escape closes, Tab stays inside the popup
  document.addEventListener('keydown', function (e) {
    if (!root) return;
    if (e.key === 'Escape') { close('x'); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(root.querySelectorAll('button:not([disabled]):not([hidden]), select:not([disabled]), a[href]:not([tabindex="-1"])'));
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !root.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !root.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  window.addEventListener('resize', function () { drawArrows(); });

  /* --------------------------------------------------------- trigger
     main-product calls KukoonSet.afterAdd(handle) once the product (and its
     underlay, if chosen) is really in the basket. Nothing to offer, closed
     twice this visit, or anything failing: the drawer opens as before. */
  /* 15 Oct 2026 (Jack): the rug's own underlay as the second card. Underlay is the
     biggest add-on in the shop (about a third of rug orders) and the popup used to
     skip it. Only when the rug added has none in the basket yet, and only the one
     sized for it - read from the size option just added, which the product page
     already carries (data-underlay-*). Added the way the product page adds it
     (_underlay_for = the rug's variant), so the basket keeps it with its rug. */
  function underlayFor(variantId, cart, me) {
    if (!variantId || !me || ['rug', 'runner', 'circle'].indexOf(kind(me)) === -1) return null;
    var o = document.querySelector('option[value="' + variantId + '"][data-underlay-id]');
    if (!o || o.getAttribute('data-underlay-available') === 'false') return null;
    var uid = o.getAttribute('data-underlay-id');
    var has = (cart.items || []).some(function (i) {
      return String(i.variant_id) === uid || (i.properties && String(i.properties._underlay_for || '') === String(variantId));
    });
    if (has) return null;
    var priceText = o.getAttribute('data-underlay-price') || '';
    var amount = Number(priceText.replace(/[^\d.,]/g, '').replace(/,(\d{2})$/, '.$1').replace(/,/g, ''));
    var rugQty = 1;
    (cart.items || []).forEach(function (i) { if (String(i.variant_id) === String(variantId)) rugQty = Math.max(1, i.quantity || 1); });
    var row = null;
    (INDEX_ROWS || []).forEach(function (r) { if (r.h === 'non-slip-rug-underlay') row = r; });
    return { why: 'underlay', p: { h: 'non-slip-rug-underlay', t: 'Anti-slip underlay', im: [o.getAttribute('data-underlay-image') || ''],
      r: row && row.r, rc: row && row.rc },
      u: { id: uid, price: priceText, amount: amount, size: o.getAttribute('data-underlay-size') || '', parent: String(variantId), qty: rugQty } };
  }
  function underlayCard(x, i, range) {
    var u = x.u;
    var size = String(u.size || '').replace(/\s*\(.*\)\s*$/, '');
    return '<li class="kset-card kset-ul" data-h="' + esc(x.p.h) + '" data-i="' + i + '">' +
      '<span class="kset-img" aria-hidden="true">' + (x.p.im[0] ? '<img src="' + esc(img(x.p.im[0], 500)) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="kset-name">Anti-slip underlay</span>' +
      '<span class="kset-match">Stops slips, protects floors</span>' +
      stars(x.p) +
      '<span class="kset-price" data-price>' + esc(u.price) + '</span>' +
      // a fixed size, drawn like the size dropdown so the rows line up
      '<span class="kset-size"><span class="kset-fixed">' + esc(size || 'Sized for your rug') + '</span></span>' +
      '<input type="hidden" data-v value="' + esc(u.id) + '" data-a="' + (u.amount || 0) + '" data-w="0" data-c="' + esc(CURRENCY) + '"' +
        ' data-ul-for="' + esc(u.parent) + '" data-ul-qty="' + (u.qty || 1) + '">' +
      '<span class="kset-hint" data-hint data-def="Sized for your ' + esc(range ? range + ' ' : '') + 'rug">Sized for your ' + esc(range ? range + ' ' : '') + 'rug</span>' +
      '<span class="kset-sp" aria-hidden="true"></span>' +
      '<button type="button" class="kset-add' + (i === 0 ? ' is-pick' : '') + '" data-add>+ Add</button>' +
      '</li>';
  }
  function afterAdd(handle, variantId) {
    var dismissed = false;
    try { var dm = JSON.parse(sessionStorage.getItem(DISMISS) || '{}'); dismissed = !!(dm && typeof dm === 'object' && dm[handle]); } catch (e) {}
    if (dismissed) { openDrawer(); return Promise.resolve(false); }
    state.source = handle;
    state.variant = String(variantId || '');
    return Promise.all([loadIndex(), getCart()]).then(function (res) {
      var index = res[0], cart = res[1], inCart = {}, me = null;
      INDEX_ROWS = index;
      (cart.items || []).forEach(function (i) { inCart[i.handle] = 1; });
      for (var i = 0; i < index.length; i++) if (index[i].h === handle) { me = index[i]; break; }
      CHOSEN = ((cart.items || []).filter(function (i) { return String(i.variant_id) === state.variant; })[0] || {}).variant_title || '';
      var items = me ? pick(index, handle, inCart) : [];
      if (!items.length) { openDrawer(); return false; }
      return live(items.map(function (x) { return x.p.h; })).then(function (l) {
        var ranked = rankForTier(items, l, cart);
        // 15 Oct 2026 (Jack): only when the set has ONE piece to offer (e.g. Dusk, just a
        // runner) - bigger popups stay as they were. Baskets are stamped only in that case
        // too, so the test compares like with like.
        // the underlay card test ended 20 Oct 2026 - no card, and no _kset_ul stamp
        var shown = open(ranked, l, cart, me);
        if (!shown) openDrawer();
        return shown;
      });
    }).catch(function () { openDrawer(); return false; });
  }
  if (/\/products\//.test(location.pathname)) {
    // Warm-up only, so it can never stop the popup starting. (It once did:
    // requestIdleCallback(fn, 1500) throws in Chrome - its second argument
    // must be {timeout}, not a number - and the popup never registered.)
    /* 12 Oct 2026: warmed when the shopper reaches for the add-to-cart form
       (picking a size, pressing Add), not when the page goes idle - most
       product views never add, and this was a full index download each. */
    try {
      var warm = function (e) {
        if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"], product-form, [data-product-form]')) {
          loadIndex();
          document.removeEventListener('pointerdown', warm, true);
          document.removeEventListener('focusin', warm, true);
        }
      };
      document.addEventListener('pointerdown', warm, true);
      document.addEventListener('focusin', warm, true);
    } catch (e) {}
  }
  window.KukoonSet = { get active() { return gate(); }, afterAdd: afterAdd, pick: pick, kind: kind, _load: loadIndex };
})();
